import captureSentryException from '@/features/app/functions/captureSentryException';
import getPushTokenProvider from '@/features/push/providers/get-push-token-provider';
import usePushDeviceRegistrationStore from '@/features/push/stores/push-device-registration';
import useAxios from '@/shared/hooks/useAxios';
import { useMutation } from '@tanstack/react-query';

export default function useUnregisterPushDeviceMutation() {
  const axios = useAxios();

  return useMutation({
    async mutationFn() {
      const { registration, clearRegistration } = usePushDeviceRegistrationStore.getState();

      if (registration?.id) {
        try {
          await axios.delete(`/api/v1/user-device/${registration.id}`);
        } catch (error) {
          captureSentryException(error, {
            tags: { feature: 'push.unregister' },
          });
        }
      }
      clearRegistration();

      try {
        await getPushTokenProvider().clearToken();
      } catch (error) {
        captureSentryException(error, {
          tags: { feature: 'push.clearLocalToken' },
        });
      }
    },
  });
}
